// Lib
import React, { useMemo } from 'react';

// Components
import Table from '../../Table';
import ProductCard from './ProductCard';
import TableRow from './TableRow';

// Hooks
import useUI from '../../../hooks/useUI';
import useProductsCellReducers from '../../../pages/Approvals/hooks/useProductsCellReducers';

// Constants
import { PRODUCTS_COLUMNS } from '../../../constants/approvals';

import { useStyles } from './ProductsListStyles';

const ProductsList = ({ approvals, addressesCount, isMethodPage = false }) => {
  const { classes } = useStyles({ isDistro: addressesCount > 1, isMethodPage });
  const { isDesktopMode } = useUI();

  const products = useMemo(() => {
    if (approvals?.approvals) {
      return Object.keys(approvals?.approvals?.products_limits).map(
        (productId) => ({
          ...approvals.approvals?.products_limits[productId],
          product_id: productId,
          ...approvals.approvals?.products_limits[productId].product_details,
        }),
      );
    }
    return [];
  }, [approvals]);

  const productsForApprove = useMemo(
    () =>
      isMethodPage ? products : products.filter((product) => product.approvers),
    [products, isMethodPage],
  );

  return (
    <>
      {isDesktopMode ? (
        <Table
          useCellsReducers={useProductsCellReducers}
          data={productsForApprove}
          TableRow={TableRow}
          columns={PRODUCTS_COLUMNS(addressesCount > 1, isMethodPage)}
          styles={classes}
          props={{ addressesCount, isMethodPage }}
        />
      ) : (
        productsForApprove.map((product) => {
          return (
            <ProductCard
              isMethodPage={isMethodPage}
              addressesCount={addressesCount}
              key={product.product_id}
              product={product}
            />
          );
        })
      )}
    </>
  );
};

export default ProductsList;
